import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
import VoiceRoomImProvider from '@/components/VoiceRoom/voiceRoomIM';
import { getEmojiList } from '@/api/voice-room';
export class ChatMessage {
  nickName = '';
  action = '';
  userId = '';
  userInfo = {};
  message = '';
  level = '';
  giftInfo = {};
  emojiInfo = {};
  dressup = {};
  get pfpFrame() {
    if (this.userInfo.pfpFrame) {
      return JSON.parse(this.userInfo.pfpFrame);
    } else {
      return {};
    }
  }
  constructor(message) {
    for (let i in message) {
      this[i] = message[i];
    }
  }
}
class Chat {
  messageList = [];
  emojiList = [];
  constructor() {
    // this.getEmojiList();
  }
  init() {
    this.messageList = [];
    this.getEmojiList();
  }
  async leaveRoom(message) {
    await this.addNewMessage(message);
  }
  async addNewMessage(message) {
    if (message.userId) {
      message.userInfo =
        (await VoiceRoomImProvider.getMemberProfile(message.userId)) || {};
    }
    // const level = await VoiceRoomImProvider.getMemberLevel(message.userId);
    message.level = message.userInfo
      ? message.userInfo.userLevel
      : message.level;
    message.level = message.level ? Number(message.level) : null;
    if (message.action === 'emojiReceive') {
      if (!this.emojiList) {
        await this.getEmojiList();
      }
      const imageUrlList = message.imageUrlList;
      const emojiInfo = this.emojiList.find(item => {
        // ios和安卓不統一，暫時判斷石頭布
        if (message.name.includes('石頭布') && item.name.includes('石頭布')) {
          return item;
        } else {
          return item.name === message.name;
        }
      });
      message.emojiInfo = JSON.parse(JSON.stringify(emojiInfo));
      if (message.name.includes('石頭布')) {
        const imageUrl = imageUrlList[imageUrlList.length - 1];
        const index =
          imageUrl === 'emoji_jiandao.webp'
            ? 0
            : imageUrl === 'emoji_bu.webp'
            ? 1
            : 2;
        message.emojiInfo.imageUrlList = [emojiInfo.imageUrlList[index]];
      }
    }
    this.messageList.push(message);
  }
  async getEmojiList() {
    if (this.emojiList && this.emojiList.length > 0) {
      return this.emojiList;
    }
    const { data } = await getEmojiList();
    if (data) {
      this.emojiList = data;
    }
  }
}
const chatProvider = new Chat();
VoiceRoomEventEmitter.on(VoiceRoomEvent.leaveRoom, message => {
  chatProvider.leaveRoom(message);
});
VoiceRoomEventEmitter.on(VoiceRoomEvent.addNewMessage, message => {
  chatProvider.addNewMessage(message);
});
export default chatProvider;
